import React, { useCallback } from 'react';
import { COLORS, Icon } from '@livecommerce/design-system';
import { styled } from '@linaria/react';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import HeaderItem from './HeaderItem.jsx';
import useChatBot from 'components-v3/AIChatBot/useChatBot.js';

const StyledHeaderItem = styled(HeaderItem)`
  border-radius: 4px;
  cursor: pointer;
  display: flow-root;
  &:hover {
    background-color: ${COLORS.dark_600};
  }
`;

const HeaderItemContents = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
`;

const AIChatBotHeaderItem = () => {
  const { t } = useLocalization();
  const { isInitialized, isOpen, open, close } = useChatBot();

  const onClick = useCallback(() => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }, [isOpen, open, close]);

  if (!isInitialized) {
    return null;
  }

  return (
    <StyledHeaderItem label={t('aiAssistant.title')} onClick={onClick}>
      <HeaderItemContents>
        <Icon name="ai" color={COLORS.orange_500} />
      </HeaderItemContents>
    </StyledHeaderItem>
  );
};

export default AIChatBotHeaderItem;
